import { CheckCircleOutlined, CloseOutlined, PauseOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Button, Form, Popconfirm, Popover } from 'antd'
import * as React from 'react'
import type { Ratebook } from '@api/useFreight/types'
import { useBillingStatusBanner } from '../hooks'
import { ActivationForm } from './ActivationForm'

interface BillingStatusBannerProps {
  status: string
  ratebook: Ratebook
}

export function BillingStatusBanner({ status, ratebook }: BillingStatusBannerProps) {
  const [form] = Form.useForm()

  const {
    currentStatus,
    setCurrentStatus,
    isPopoverOpen,
    setIsPopoverOpen,
    config,
    contextHolder,
    createRatebookMutation,
    setHoldMutation,
    removeHoldMutation,
  } = useBillingStatusBanner(ratebook, status)

  // Map string icons to actual components
  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'CheckCircleOutlined':
        return <CheckCircleOutlined />
      case 'PauseOutlined':
        return <PauseOutlined />
      case 'CloseOutlined':
        return <CloseOutlined />
      default:
        return null
    }
  }

  return (
    <>
      {contextHolder}
      <Horizontal
        style={{ maxWidth: 500 }}
        bg={config.background}
        border='all'
        borderRadius='6px'
        className='py-1 px-3'
        verticalCenter
        gap={16}
      >
        {getIconComponent(config.icon)}
        <Vertical>
          <Texto weight='bold'>{config.title}</Texto>
          <Texto style={{ marginBottom: '-15px' }}>{config.description}</Texto>
        </Vertical>
        {currentStatus === 'No Invoice' ? (
          <Popover
            content={
              <ActivationForm
                form={form}
                ratebook={ratebook}
                setIsPopoverOpen={setIsPopoverOpen}
                setCurrentStatus={setCurrentStatus}
              />
            }
            title='Configure Invoicing Start'
            trigger='click'
            placement='bottomLeft'
            overlayStyle={{ width: 400 }}
            overlayInnerStyle={{ padding: '16px 24px' }}
            open={isPopoverOpen}
            onOpenChange={setIsPopoverOpen}
          >
            <GraviButton size='small' loading={isPopoverOpen && createRatebookMutation.isPending}>
              {config.action}
            </GraviButton>
          </Popover>
        ) : (
          <Popconfirm
            title={config.confirmMessage}
            onConfirm={config.handleConfirm}
            okText='Yes'
            cancelText='No'
            placement='topLeft'
          >
            <Button
              size='small'
              icon={currentStatus === 'Active' ? <PauseOutlined /> : undefined}
              loading={setHoldMutation.isPending || removeHoldMutation.isPending}
            >
              {config.action}
            </Button>
          </Popconfirm>
        )}
      </Horizontal>
    </>
  )
}
